import { useCallback, useContext, useMemo } from 'react'
import { Observable } from 'rxjs'

import { AuthStateContext } from '@/modules/auth/context.ts'
import { AuthState } from '@/system/rxdb/replication.ts'

export const useAuthState = () => {
  const authState = useContext(AuthStateContext)

  const onLoginDone = useCallback(() => {
    void authState?.set('requireAuthentication', () => 'IS_NOT_REQUIRED')
  }, [authState])

  const observeAuthenticationState = useCallback(() => {
    return authState?.get$('requireAuthentication') as Observable<AuthState>
  }, [authState])

  return useMemo(
    () => ({ onLoginDone, observeAuthenticationState, authState }),
    [onLoginDone, authState, observeAuthenticationState]
  )
}
